import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

const CustomDatePicker = ({ label, field, errors, format = "DD-MM-YYYY" } : any) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                {...field}
                label={label}
                format={format}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        error: !!errors.startsAt,
                        helperText: errors.startsAt?.message,
                    },
                }}
            />
        </LocalizationProvider>
    )
}

export default CustomDatePicker